import { TSource } from '../types/types';

const paywallPages = ['horoscopes', 'compatibility', 'chat', 'predictions', 'tarot'] as const;
type TPaywallPages = (typeof paywallPages)[number];

export const getPaywallPage = (source: TSource): TPaywallPages => {
  switch (source) {
    case 'vanga':
      return 'chat';
    case 'compatibility-long':
      return 'compatibility';
    case 'compatibility-short':
      return 'compatibility';
    case 'messenger':
      return 'chat';
    case 'tarot':
      return 'tarot';
    case 'tarot-chat':
      return 'tarot';
    case 'witch':
      return 'horoscopes';
    case 'pope-long':
      return 'chat';
    case 'pope-short':
      return 'chat';
    default:
      return 'chat';
  }
};
